/* eslint-disable camelcase */
import { Organization } from 'scenes/Dashboard/data/organizations/types'
import { Person } from 'scenes/Dashboard/data/people/types'

import { ApiEntity, DateTrustCode, Entity, EntityId } from '../common'

export enum OrganizationStage {
  Acquired = 'acquired',
  Corporate_Round = 'corporate_round',
  Debt_Financing = 'debt_financing',
  Pre_Seed = 'pre_seed',
  Private_Equity = 'private_equity',
  Public = 'public',
  Seed = 'seed',
  Series_A = 'series_a',
  Series_B = 'series_b',
  Series_C = 'series_c',
  Series_D = 'series_d',
  Series_E = 'series_e',
  Series_F = 'series_f',
  Other = 'other',
  Series_Unknown = 'series_unknown',
}

export enum RoundType {
  preSeed = 'Pre-Seed',
  seed = 'Seed',
  postSeed = 'Post-Seed',
  venture = 'Venture',
  equityCrowdfunding = 'Equity Crowdfunding',
  productCrowdfunding = 'Product Crowdfunding',
  privateEquity = 'Private Equity',
  convertibleNote = 'Convertible Note',
  debtFinancing = 'Debt Financing',
  secondaryMarket = 'Secondary Market',
  grant = 'Grant',
  postIpoEquity = 'Post-IPO Equity',
  postIpoDebt = 'Post-IPO Debt',
  nonEquityAssistance = 'Non-Equity Assistance',
  undisclosed = 'Undisclosed',
  corporateRound = 'Corporate Round',
  initialCoinOffering = 'Initial Coin Offering',
  postIPOSecondary = 'Post-IPO Secondary',
  seriesA = 'Series A',
  seriesB = 'Series B',
  seriesC = 'Series C',
  seriesD = 'Series D',
  seriesE = 'Series E',
  seriesF = 'Series F',
  seriesG = 'Series G',
  seriesH = 'Series H',
  seriesI = 'Series I',
  seriesJ = 'Series J',
  ventureSeriesUnknown = 'Venture - Series Unknown',
  bridge = 'Bridge',
  mAndA = 'M&A',
  ipo = 'IPO',
}

export type FundingRound = Entity & {
  readonly companyId: EntityId
  readonly roundType?: string
  readonly announcedOn?: string
  readonly announcedOnTrustCode?: DateTrustCode
  readonly closedOn?: string
  readonly closedOnTrustCode?: DateTrustCode
  readonly roundSize?: number
  readonly roundSizeCurrency?: string
  readonly targetMoney?: number
  readonly targetMoneyCurrency?: string
  readonly valuationPreMoney?: number
  readonly valuationPreMoneyCurrency?: string
  readonly committedCapital?: number
  readonly committedCapitalCurrency?: string
  readonly roundTerms?: string
  readonly committedInvestors?: string
  readonly investments: Investment[]
}

export type APIFundingRound = Omit<FundingRound, 'investments'> &
  ApiEntity & {
    readonly investments?: APIInvestment[]
  }

export type FundingRoundDto = Partial<Omit<FundingRound, 'investments'>>

export type Investment = Entity & {
  readonly fundingRoundId: EntityId
  readonly organization?: Pick<Organization, 'name' | 'id'>
  readonly organizationId?: EntityId
  readonly person?: Person
  readonly personId?: EntityId
  readonly isLead: boolean
}

export type APIInvestment = Investment & ApiEntity

export type CurrentFundingRoundData = Omit<FundingRound, 'id' | 'companyId'>

export const FUNDING_ROUND_CACHE_STORE_ID = 'fundingRounds'
